var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuotation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1664",
    "data-name": "Group 1664",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.241,
    height: 41.203,
    viewBox: "0 0 33.241 41.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1551",
    "data-name": "Rectangle 1551",
    className: "cls-1",
    width: 33.241,
    height: 41.203
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1950",
    "data-name": "Group 1950",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    "data-name": "Path 4068",
    className: "cls-1",
    d: "M30.3,0c.229.07.464.123.685.212a3.341,3.341,0,0,1,2.229,2.934,5.9,5.9,0,0,1,.023.6q0,16.858.005,33.717a3.416,3.416,0,0,1-2.052,3.426,3.506,3.506,0,0,1-1.4.3q-13.177.026-26.354.009a3.389,3.389,0,0,1-3.419-3.22C.005,37.8,0,37.63,0,37.456q0-8.992,0-17.985a2.651,2.651,0,0,1,.025-.481.543.543,0,0,1,.6-.482.537.537,0,0,1,.56.476,2.947,2.947,0,0,1,.026.521q0,6.357,0,12.714v.507h30.82v-.414q0-14.344,0-28.687a2.222,2.222,0,0,0-1.834-2.382,3.054,3.054,0,0,0-.561-.034q-13.016,0-26.032,0A2.215,2.215,0,0,0,1.21,3.587q-.009,6.236,0,12.473a2.887,2.887,0,0,1-.026.521.542.542,0,0,1-.6.48.538.538,0,0,1-.558-.479A2.712,2.712,0,0,1,0,16.1Q0,9.925,0,3.749A3.428,3.428,0,0,1,2.871.043.26.26,0,0,0,2.938,0ZM1.208,33.978c0,1.25-.007,2.456,0,3.661a2.214,2.214,0,0,0,2.374,2.355q13.032,0,26.065,0a2.216,2.216,0,0,0,2.376-2.354c.01-1.113,0-2.226,0-3.338,0-.1-.017-.206-.028-.324Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    "data-name": "Path 4069",
    className: "cls-1",
    d: "M36.2,31.674c0,.456.008.911,0,1.367a1.777,1.777,0,0,1-1.781,1.8q-1.387.023-2.774,0a1.733,1.733,0,0,1-1.749-1.652c-.046-1-.044-2.011,0-3.014a1.687,1.687,0,0,1,1.628-1.642,26.426,26.426,0,0,1,3.013,0A1.744,1.744,0,0,1,36.2,30.347c.007.442,0,.885,0,1.327m-1.206.023c0-.429.006-.857,0-1.286-.008-.458-.205-.69-.646-.7q-1.305-.025-2.611,0a.591.591,0,0,0-.651.655q-.021,1.305,0,2.611a.586.586,0,0,0,.648.652q1.305.015,2.611,0a.588.588,0,0,0,.648-.65c.01-.428,0-.857,0-1.285",
    transform: "translate(-26.649 -25.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    "data-name": "Path 4070",
    className: "cls-1",
    d: "M36.181,113.347c0,.469.012.938,0,1.407a1.772,1.772,0,0,1-1.784,1.749q-1.367.016-2.734,0a1.746,1.746,0,0,1-1.789-1.7c-.04-.976-.04-1.957,0-2.934a1.737,1.737,0,0,1,1.757-1.692c.923-.033,1.85-.033,2.773,0a1.775,1.775,0,0,1,1.78,1.841c.007.442,0,.884,0,1.327ZM33,115.3c.442,0,.884.007,1.325,0a.584.584,0,0,0,.649-.645q.014-1.305,0-2.611c0-.413-.2-.645-.6-.654-.9-.02-1.794-.017-2.691,0a.57.57,0,0,0-.611.609c-.011.9-.016,1.794,0,2.691a.574.574,0,0,0,.643.611c.428.009.857,0,1.285,0",
    transform: "translate(-26.633 -98.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    className: "cls-1",
    d: "M221.87,192.9c.474.272.9.473,1.271.742a.606.606,0,1,1-.773.913,1.541,1.541,0,0,0-1.428-.325.9.9,0,0,0-.706.781.71.71,0,0,0,.459.838c.473.217.948.436,1.433.625a2.274,2.274,0,0,1,1.67,2.166,2.562,2.562,0,0,1-1.656,2.39.361.361,0,0,0-.285.4c0,.527-.207.781-.6.784s-.588-.249-.6-.774c0-.066-.008-.133-.009-.145-.5-.213-.991-.386-1.446-.621a.588.588,0,0,1-.314-.866.608.608,0,0,1,.936-.152,2.348,2.348,0,0,0,1.62.314,1.319,1.319,0,0,0,1.145-1.216,1.044,1.044,0,0,0-.691-1.066c-.528-.227-1.068-.427-1.589-.669a1.919,1.919,0,0,1-1.291-1.9,2.129,2.129,0,0,1,1.417-2.007.438.438,0,0,0,.215-.309c.054-.534.233-.779.614-.775s.582.273.6.789a.713.713,0,0,0,.007.085",
    transform: "translate(-195.274 -171.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    className: "cls-1",
    d: "M38.69,276.017h7.679a2.927,2.927,0,0,1,.441.014.588.588,0,0,1,.108,1.133,1.7,1.7,0,0,1-.515.057q-7.719,0-15.439,0c-.08,0-.161,0-.241,0-.436-.025-.689-.263-.677-.632s.254-.57.682-.571c1.662-.005,3.324,0,4.986,0H38.69",
    transform: "translate(-26.817 -246.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    className: "cls-1",
    d: "M113.795,159.135q-3.881,0-7.763,0a.877.877,0,0,1-.532-.1.753.753,0,0,1-.265-.562,1,1,0,0,1,.428-.506c.1-.073.285-.035.432-.035h15.446c.08,0,.161,0,.241,0a.624.624,0,0,1,.655.618.61.61,0,0,1-.678.585c-1.341.005-2.682,0-4.022,0h-3.942",
    transform: "translate(-93.917 -140.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    className: "cls-1",
    d: "M113.625,77.59h-7.683a2.733,2.733,0,0,1-.4-.01.556.556,0,0,1-.525-.561.567.567,0,0,1,.5-.624,1.685,1.685,0,0,1,.361-.012h15.486a2.559,2.559,0,0,1,.321.006.6.6,0,0,1,.553.627.581.581,0,0,1-.571.568c-.12.011-.241.006-.362.006h-7.683",
    transform: "translate(-93.724 -68.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    className: "cls-1",
    d: "M113.635,135.332h-7.722a2.7,2.7,0,0,1-.4-.011.543.543,0,0,1-.5-.537.536.536,0,0,1,.41-.61,1.953,1.953,0,0,1,.516-.047q7.682,0,15.364,0a1.964,1.964,0,0,1,.478.036.55.55,0,0,1,.451.623.557.557,0,0,1-.55.54c-.133.012-.268.006-.4.006h-7.642",
    transform: "translate(-93.717 -119.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    "data-name": "Path 4076",
    className: "cls-1",
    d: "M36.292,195.16c0,.5.02.993,0,1.487a1.774,1.774,0,0,1-1.713,1.653.613.613,0,0,1-.68-.538.623.623,0,0,1,.528-.656c.592-.137.668-.231.67-.841,0-.777,0-1.555,0-2.332,0-.537-.194-.745-.713-.752q-1.246-.015-2.493,0c-.5.006-.7.211-.707.722q-.014,1.246,0,2.493c.006.461.151.614.6.7.415.08.623.322.584.678s-.3.542-.724.523a1.707,1.707,0,0,1-1.628-1.509,32.029,32.029,0,0,1,0-3.292,1.607,1.607,0,0,1,1.467-1.477,30.105,30.105,0,0,1,3.292,0,1.688,1.688,0,0,1,1.519,1.656c.019.5,0,.992,0,1.487h0",
    transform: "translate(-26.749 -171.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    "data-name": "Path 4077",
    className: "cls-1",
    d: "M110.615,53.7q-2.432,0-4.864,0c-.509,0-.773-.213-.767-.608.006-.375.273-.6.75-.6q4.9,0,9.808,0a.639.639,0,0,1,.711.463.539.539,0,0,1-.307.67,1.138,1.138,0,0,1-.467.071c-1.621,0-3.242,0-4.864,0",
    transform: "translate(-93.698 -46.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    "data-name": "Path 4078",
    className: "cls-1",
    d: "M109.584,240.819q-1.911,0-3.822,0c-.514,0-.777-.209-.774-.6s.274-.6.785-.6c2.548,0,5.1-.009,7.644.013a1.045,1.045,0,0,1,.677.312.584.584,0,0,1-.006.576.97.97,0,0,1-.642.292c-1.287.026-2.575.013-3.862.013",
    transform: "translate(-93.701 -213.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    "data-name": "Path 4079",
    className: "cls-1",
    d: "M109.551,216.956c-1.287,0-2.575,0-3.862,0-.486,0-.746-.262-.7-.671.037-.331.274-.525.689-.531.684-.009,1.368,0,2.052,0h5.552a2,2,0,0,1,.4.02.557.557,0,0,1,.5.623.542.542,0,0,1-.569.555c-.469.017-.939.008-1.408.008h-2.655",
    transform: "translate(-93.698 -192.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    "data-name": "Path 4080",
    className: "cls-1",
    d: "M225.6,53.668c-.521,0-1.042.006-1.563,0-.416-.006-.657-.231-.658-.592a.594.594,0,0,1,.652-.608q1.6-.017,3.207,0a.6.6,0,1,1-.034,1.2c-.534.007-1.069,0-1.6,0",
    transform: "translate(-199.363 -46.819)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    className: "cls-1",
    d: "M139.729,326.976a2.034,2.034,0,1,1-2.043-2.047,2.039,2.039,0,0,1,2.043,2.047m-1.21.01a.825.825,0,1,0-.816.824.831.831,0,0,0,.816-.824",
    transform: "translate(-121.076 -289.997)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotation);
export default __webpack_public_path__ + "static/media/icon-quotation.1ba7f4b8dd1215b4679cd6e973f35002.svg";
export { ForwardRef as ReactComponent };